import { Box, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

const SingleCardContainer = styled(Paper)(({ theme }) => ({
  width: 800,
  margin: '5% auto',
  padding: 40,
  flexGrow: 0,
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    height: '100%',
    borderRadius: 0,
    boxShadow: 'none',
    margin: 0,
    border: 0,
    flexGrow: 1,
  },
}));

const Header = styled(Box)(({ theme }) => ({
  marginBottom: 10,
}));

const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  lineHeight: '28px',
  fontWeight: 500,
  fontSize: 24,
}));

const Description = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  lineHeight: '18px',
}));

export default function SingleCard({ title, description, children }) {
  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        overflowY: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <SingleCardContainer>
        <Header>
          <Title variant='h5'>{title}</Title>
          <Description variant='body2'>{description}</Description>
        </Header>
        {children}
      </SingleCardContainer>
    </Box>
  );
}
